module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-10-a5f45b74a406d1f65153aa082e64f811.svg";